import React from 'react'
import tts from '../../lib/TTS'
import { FocusableComponentLayout } from '@noriginmedia/norigin-spatial-navigation'
import FocusableLink from '../../components/FocusableLink/index.ts'
import { SettingsAccountProps } from './types'

const HELP_URL = 'pbs.org/pbscomcasthelp'
const MANAGE_DONATION_PATH = '/manage-donation'
const MANAGE_MY_DONATIONS_KEY = 'manageMyDonations'
const SIGN_OUT_KEY = 'signOut'
const SIGN_OUT_PATH = '/sign-out'
const TITLE = 'Account'

const SettingsAccount = ({
  donationFeatureEnabled,
  isActiveDonation,
  handleFocus,
  user,
}: SettingsAccountProps) => {
  const showDonationLink = donationFeatureEnabled && isActiveDonation

  const handleDonationFocus = (layout: FocusableComponentLayout) => {
    const textToRead = `${TITLE}. Focused on Manage My Donations`

    tts.stopRead()
    tts.addTextToRead(textToRead)

    handleFocus?.(layout)
  }

  const handleSignOutFocus = (layout: FocusableComponentLayout) => {
    const accountSignoutTTS = `${
      showDonationLink ? '' : `${TITLE}`
    } Focused on Signed in as: ${user.email}. Sign Out .... Build #: g${
      BUILD_NUMBER || ''
    }${
      COMPILING_FOR_COMCASTX1
        ? ' .... Need more help? Visit pbs.org slash pbs comcast help'
        : ''
    }`

    tts.stopRead()
    tts.addTextToRead(accountSignoutTTS)

    handleFocus?.(layout)
  }

  return (
    <div className="settings-section-container">
      <h2>{TITLE}</h2>

      {showDonationLink && (
        <FocusableLink
          focusKey={MANAGE_MY_DONATIONS_KEY}
          label="Manage My Donations"
          onFocus={handleDonationFocus}
          to={MANAGE_DONATION_PATH}
          disableTTS
        >
          <h3>Manage My Donations</h3>
        </FocusableLink>
      )}
      <FocusableLink
        focusKey={SIGN_OUT_KEY}
        label="Sign Out"
        onFocus={handleSignOutFocus}
        to={SIGN_OUT_PATH}
        disableTTS
      >
        <div className="sign-out">
          <h3>Signed in as: {user.email}</h3>
          <hr />
          <h3 className="change-account">Sign Out</h3>
        </div>
      </FocusableLink>

      <div className="underlined">Build #: g{BUILD_NUMBER}</div>

      {COMPILING_FOR_COMCASTX1 && (
        <div className="underlined text-block">
          <p>Need more help?</p>
          <p>{HELP_URL}</p>
        </div>
      )}
    </div>
  )
}

export default SettingsAccount
